import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PendingRequestsService {
    private pendingRequests = 0;
    private pendingRequestsSubject$ = new BehaviorSubject<boolean>(false);

    public hasPendingRequests$ = this.pendingRequestsSubject$.asObservable();

    public requestStart(): void {
        this.pendingRequests++;
        this.pendingRequestsSubject$.next(true);
    }

    public requestEnd(): void {
        if (this.pendingRequests > 0) {
            this.pendingRequests--;
        }

        if (this.pendingRequests === 0) {
            this.pendingRequestsSubject$.next(false);
        }
    }
}
